import Vue from 'vue'
import AkeIcon from '@/components/icon'

Vue.component('AkeIcon', AkeIcon)

const req = require.context('./svg', false, /\.svg$/)
const requireAll = (requireContext) => requireContext.keys().map(requireContext)

requireAll(req)
